export enum Types {
    SET_SAVED_CHARTS_DATA = "setSavedChartsData",
    ADD_SAVED_CHART_DATA = "addSavedChartData",
    UPDATE_SAVED_CHART_DATA = "updateSavedChartData",
    REMOVE_SAVED_CHART_DATA = "removeSavedChartData",
}
